import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryTabs() {
  const [active, setActive] = useState('all');

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            浏览分类
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              type="button"
              onClick={() => setActive(cat.slug)}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                active === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:text-foreground-950 hover:bg-background-200 border border-background-200/60'
              }`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}